import { ResponsivePie } from "@nivo/pie";

const MedicationPieChart = () => {
  const data = [
    { id: "Completed", label: "Completed", value: 60 },
    { id: "Pending", label: "Pending", value: 30 },
    { id: "Missed", label: "Missed", value: 10 },
  ];

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 h-96">
      <h3 className="text-lg font-semibold text-slate-700 mb-4">
        Medication Status
      </h3>

      <ResponsivePie
        data={data}
        innerRadius={0}   // full cake
        padAngle={1}
        cornerRadius={6}
        activeOuterRadiusOffset={8}
        colors={["#22C55E", "#F59E0B", "#EF4444"]}
        borderWidth={1}
        borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
        enableArcLabels={true}
        arcLabelsTextColor="#ffffff"
      />
    </div>
  );
};

export default MedicationPieChart;